/**
 * SpecialtyPharmacyPreDeterminationProcessSection - Output section for SP pre-det process
 *
 * Displays specialty pharmacy pre-determination process as a top-level accordion section.
 */

import { AccordionContent, AccordionItem, AccordionTrigger } from '@components/ui/accordion';
import React from 'react';

import { FieldPathProvider } from '../context';
import { Field, SectionTriggerScore } from './Field';

interface SpecialtyPharmacyPreDeterminationProcessSectionProps {
  data?: Record<string, unknown>;
  sectionId: string;
}

export const SpecialtyPharmacyPreDeterminationProcessSection: React.FC<
  SpecialtyPharmacyPreDeterminationProcessSectionProps
> = ({ data, sectionId }) => {
  return (
    <AccordionItem value={sectionId} className="border-b">
      <AccordionTrigger className="px-4 py-3 text-sm font-medium hover:bg-muted/50">
        <div className="flex items-center gap-2 flex-1">
          <span>Drug Specialty Pharmacy Pre Determination Process</span>
          <SectionTriggerScore subsectionKey="specialty_pharmacy_pre_determination_process" />
        </div>
      </AccordionTrigger>
      <AccordionContent className="px-4 pb-4">
        <FieldPathProvider prefix="drug.specialty_pharmacy_pre_determination_process">
          <div className="grid grid-cols-2 gap-x-4 gap-y-1">
            <Field
              label="Department Name"
              value={data?.specialty_pharmacy_pre_determination_department_name}
              fieldId="specialty_pharmacy_pre_determination_department_name"
            />
            <Field
              label="Turnaround Time"
              value={data?.specialty_pharmacy_pre_determination_turnaround_time}
              fieldId="specialty_pharmacy_pre_determination_turnaround_time"
            />
            <Field
              label="Fax Number"
              value={data?.specialty_pharmacy_pre_determination_fax_number}
              fieldId="specialty_pharmacy_pre_determination_fax_number"
            />
            <Field
              label="Phone Number"
              value={data?.specialty_pharmacy_pre_determination_phone_number}
              fieldId="specialty_pharmacy_pre_determination_phone_number"
            />
            <Field
              label="Website"
              value={data?.specialty_pharmacy_pre_determination_website}
              fieldId="specialty_pharmacy_pre_determination_website"
            />
            <Field
              label="Submission Methods"
              value={data?.specialty_pharmacy_pre_determination_submission_methods}
              fieldId="specialty_pharmacy_pre_determination_submission_methods"
            />
            <Field
              label="Notification Methods"
              value={data?.specialty_pharmacy_pre_determination_notification_methods}
              fieldId="specialty_pharmacy_pre_determination_notification_methods"
            />
            <div className="col-span-2">
              <Field
                label="Requirements"
                value={data?.specialty_pharmacy_pre_determination_requirements}
                fieldId="specialty_pharmacy_pre_determination_requirements"
              />
            </div>
          </div>
        </FieldPathProvider>
      </AccordionContent>
    </AccordionItem>
  );
};
